import React from 'react'
import ContactForm from './ContactForm'
import ContactHero from './ContactHero'
import ContactBody from './ContactBody'

function ContactHome() {
  return (
    <div >
      <ContactHero />
      <ContactBody />
    </div>
  )
}

export default ContactHome
